import { render, staticRenderFns } from "./ConnectionRecord.vue?vue&type=template&id=74c04bfd&scoped=true"
import script from "./ConnectionRecord.vue?vue&type=script&lang=ts"
export * from "./ConnectionRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c04bfd",
  null
  
)

export default component.exports